import React from 'react';
import useThemeVersion from '@/hooks/useThemeVersion';

function getDisplayName<P>(Component: React.ComponentType<P>): string {
  return Component.displayName || Component.name || 'Component';
}

function withLegacyVersion<T, P>(NewComponent: React.ComponentType<P>, LegacyComponent: React.ComponentType<P>, withForwardedRef: boolean = true) {
  let newComponentIsDisplayed = false;

  const WrapperComponent = (props: P, ref: React.Ref<T>) => {
    const { isLightVersion } = useThemeVersion();

    if (isLightVersion) {
      newComponentIsDisplayed = true;
      return <NewComponent {...props} ref={withForwardedRef ? ref : undefined} />;
    }

    return <LegacyComponent {...props} ref={withForwardedRef ? ref : undefined} />;
  };

  const newComponentName = getDisplayName(NewComponent);
  const legacyComponentName = getDisplayName(LegacyComponent);
  const displayName = newComponentIsDisplayed ? newComponentName : legacyComponentName;
  WrapperComponent.displayName = `withLegacyVersion(${displayName})`;

  const ForwardedWrapperComponent = withForwardedRef ? React.forwardRef(WrapperComponent) : WrapperComponent;

  return ForwardedWrapperComponent;
}

export default withLegacyVersion;
